import type { FunnelTemplate } from "@/lib/funnel-planner/engine";

export const ecommerceDtcTemplate: FunnelTemplate = {
  id: "ecommerce-dtc",
  serviceLine: "other",
  recommendedBands: ["starter", "growth"],
  pdfAccentColor: "#F97316",
  defaultTrafficChannels: [
    { id: "facebook_ads",       label: "Facebook / Instagram Ads", monthlyVisitors: 300, acquisitionType: "cpc", cpc: 1.20 },
    { id: "google_ads",         label: "Google Ads",           monthlyVisitors: 200, acquisitionType: "cpc", cpc: 0.85 },
    { id: "email_newsletter",   label: "Email Newsletter",     monthlyVisitors: 150, acquisitionType: "organic" },
    { id: "tiktok",             label: "TikTok",               monthlyVisitors: 100, acquisitionType: "organic" },
    { id: "retargeting",        label: "Retargeting",          monthlyVisitors: 80,  acquisitionType: "cpc", cpc: 0.60 },
  ],
  defaultStages: [
    { id: "landing-page",        conversionRate: 35,  isEditable: true,  stageType: "landing-page" },
    { id: "product-detail-page", conversionRate: 18,  isEditable: true,  stageType: "landing-page" },
    { id: "order-form",          conversionRate: 68,  isEditable: true,  stageType: "order-form" },
    { id: "order-bump",          conversionRate: 28,  isEditable: true,  stageType: "order-bump" },
    { id: "upsell",              conversionRate: 20,  isEditable: true,  stageType: "upsell" },
    { id: "thank-you-page",      conversionRate: 100, isEditable: false, stageType: "thank-you-page" },
  ],
};
